<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button" @click="onMenuToggle">
			<span class="pi pi-bars"></span>
		</button>
		<div class="layout-topbar-icons">
			<button class="p-link" @click="toggle">
				<span class="layout-topbar-item-text">Settings</span>
				<span class="layout-topbar-icon pi pi-cog"></span>
			</button>
			<UserPreferences :key="showConfigurationKey" v-if="showConfiguration" :reference="reference"></UserPreferences>
		</div>
	</div>
</template>

<script>
import UserPreferences from "@/components/UserPreferences";
export default {
	components: {UserPreferences},

	data(){
		return {
			showConfiguration: false,
			reference: {},
			showConfigurationKey: 0,
		}
	},

	methods: {
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		toggle(event){
			this.reference = event;
			this.showConfigurationKey++;
			this.showConfiguration = false;
			this.showConfiguration = true;
		}
    }
}
</script>
<style>

	body .p-overlaypanel {
		position: fixed !important;
		display: block !important;
		left: 1040px;
	}

	.p-overlaypanel:before {
		margin-left: 48px!important;
		border-left-width: 10px!important;
	}

	.p-overlaypanel:after{
		margin-left: 50px!important;
	}

</style>
